export const cubicOutEasing = (t: number): number => --t * t * t + 1;
